import { Box, Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import { useGetCulturesQuery } from "../../api/apiSlice";
import { Table } from "../../components";
import { OneLiner } from "../../components/Table/Table";
import { userFriendlyDateTimestamp } from "../../utils/timestamps";
import { IPreviewCultureCategory, TabLabelEnum } from "../../utils/types";

interface Props {
  category: IPreviewCultureCategory;
  handleClose: () => void;
}

export const ViewCategoryCultures: React.FC<Props> = props => {
  const { category, handleClose } = props;

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const {
    data: rowData,
    isLoading,
    isFetching,
  } = useGetCulturesQuery({
    cultureCategoryIds: category.id,
    per_page: pagination.pageSize,
    page: pagination.pageIndex + 1,
    sortBy: "culture",
    sortOrder: "ASC",
  });

  const columns = useMemo(() => {
    return [
      { accessorKey: "culture", header: "Culture", size: 200, Cell: ({ row }: any) => <OneLiner text={row.original.culture} /> },
      {
        accessorKey: "published",
        header: "Status",
        Cell: ({ row }: any) =>
          row.original.published === 0
            ? TabLabelEnum.Unpublished
            : row.original.published === -1
              ? TabLabelEnum.ReadyForReview
              : TabLabelEnum.Published,
      },
      { accessorKey: "totalQuotes", header: "Total Quotes", Cell: ({ row }: any) => <OneLiner text={String(row.original.totalQuotes ?? 0)} /> },
      { accessorKey: "totalSubscribers", header: "Subscribers", Cell: ({ row }: any) => <OneLiner text={String(row.original.totalSubscribers ?? 0)} /> },
      {
        accessorKey: "createdAt",
        header: "Created At",
        Cell: ({ row }: any) => userFriendlyDateTimestamp(row.original.createdAt),
      },
    ];
  }, []);

  return (
    <Box>
      <DialogTitle>
        <Typography variant="h6">Cultures in "{category.name}" category</Typography>
      </DialogTitle>
      <DialogContent>
        {!isLoading && !isFetching && rowData?.total === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
            <DialogContentText id="alert-dialog-description">No cultures found for this category</DialogContentText>
          </Box>
        ) : (
          <Table
            enableStickyHeader
            columns={columns}
            data={rowData?.data ?? []}
            manualPagination
            onPaginationChange={setPagination}
            state={{ pagination }}
            rowCount={rowData?.total ?? 0}
            loading={isLoading || isFetching}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button disableElevation variant="outlined" sx={{ width: 100, borderRadius: "20px" }} onClick={handleClose} type="button">
          Cancel
        </Button>
      </DialogActions>
    </Box>
  );
};
